import { Switcher, SwitcherProps } from "@xapp/components";
import { App } from "generated/graphql";
import React, { FC } from "react";
import { useHistory } from "react-router";

export type AppSwitcherApp = Pick<App, "name" | "smallIcon" | "appId" | "organizationId">;

export interface AppSwitcherProps extends Pick<SwitcherProps, "search" | "onSearchChange" | "showItems" | "onShowItemsChange" | "isLoading" | "isLoadingItems"> {
    /**
     * Total apps available
     */
    readonly totalApps: number;
    /**
     * Apps to show in the list
     */
    readonly apps?: readonly AppSwitcherApp[];
    /**
     * Current app
     */
    readonly app: AppSwitcherApp | undefined;

    onSelectApplication(organization: AppSwitcherApp): void;

    /**
     * finished saves the status of the request and also the
     * number of records found, so we can handle the loader
     * and the message of no records found without need of
     * create anoter variable for this.
     */
    finished: number | boolean;
}

export const AppSwitcher: FC<AppSwitcherProps> = (props) => {
    const { app, apps: items, search, onSearchChange, totalApps, finished } = props;

    const { push } = useHistory();

    const handleNameClick = (value: AppSwitcherApp) => {
        if (value) {
            push(`/${value.organizationId}/${value.appId}`);
        }
    };

    return (
        <Switcher
            items={items}
            placeholder="Select Application"
            searchPlaceholder="Choose an Application"
            emptyMessage="No Applications found matching"
            label="Search for application"
            search={search}
            onValueClick={handleNameClick}
            onChange={props.onSelectApplication}
            onSearchChange={onSearchChange}
            value={app}
            isLoading={props.isLoading}
            isLoadingItems={props.isLoadingItems}
            showItems={props.showItems}
            onShowItemsChange={props.onShowItemsChange}
            itemsTotal={totalApps}
            finished={finished}
        />
    );
};
